import Vue from 'vue'
import Router from 'vue-router'
import SignIn from '@/page/signIn'
import Layout from '@/page/layout'
import Index from '@/page/index'
import UserManage from '@/page/userManage'
import OperationData from '@/page/operationData'
import ToolManage from '@/page/toolManage'
import CardManage from '@/page/cardManage'
import ShopManage from '@/page/shopManage'
import UserMail from '@/page/userMail'
import ConsoleUserInfo from '@/page/user/consoleUserInfo'
import ClientUserInfo from '@/page/user/clientUserInfo'
import BaseActive from '@/page/baseActive'
import AccountManage from '@/page/accountManage'
import PropsConfig from '@/page/configs/propsConfig'
import CatCardConfig from '@/page/configs/catCardConfig'
import ApproveCenter from '@/page/approveCenter'
import CreateUser from '@/page/user/createUser'
import ActivityList from '@/page/activity/activityList.vue'
import ActivitySwitch from '@/page/activity/activitySwitch.vue'
import TaskConfig from '@/page/task/taskConfig.vue'
import Inventory from '@/page/task/inventory.vue'
import CatGuessList from '@/page/guess/catGuessList.vue'
import GuessList from '@/page/guess/guessList.vue'
import GuessSwitch from '@/page/guess/guessSwitch.vue'
import MomentList from '@/page/appIndex/momentList.vue'
import AddMoment from '@/page/appIndex/addMoment.vue'
import MomentDetail from '@/page/appIndex/momentDetail.vue'
import PresentMail from '@/page/mail/presentMail.vue'
import SystemMail from '@/page/mail/systemMail.vue'
import UploadCover from '@/page/task/uploadCover.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/Layout',
      name: 'Layout',
      component: Layout,
      children: [{
        path: '/',
        name: 'Index',
        component: Index
      }, {
        path: '/Layout/UserManage',
        name: 'UserManage',
        component: UserManage
      }, {
        path: '/Layout/OperationData',
        name: 'OperationData',
        component: OperationData
      }, {
        path: '/Layout/ActivityList',
        name: 'ActivityList',
        component: ActivityList
      }, {
        path: '/Layout/ActivitySwitch',
        name: 'ActivitySwitch',
        component: ActivitySwitch
      }, {
        path: '/Layout/ToolManage',
        name: 'ToolManage',
        component: ToolManage
      }, {
        path: '/Layout/ShopManage',
        name: 'ShopManage',
        component: ShopManage
      }, {
        path: '/Layout/CardManage',
        name: 'CardManage',
        component: CardManage
      }, {
        path: '/Layout/UserMail',
        name: 'UserMail',
        component: UserMail
      }, {
        path: '/Layout/ConsoleUserInfo',
        name: 'ConsoleUserInfo',
        component: ConsoleUserInfo
      }, {
        path: '/Layout/ClientUserInfo',
        name: 'ClientUserInfo',
        component: ClientUserInfo
      }, {
        path: '/Layout/BaseActive',
        name: 'BaseActive',
        component: BaseActive
      }, {
        path: '/Layout/AccountManage',
        name: 'AccountManage',
        component: AccountManage
      }, {
        path: '/Layout/PropsConfig',
        name: 'PropsConfig',
        component: PropsConfig
      }, {
        path: '/Layout/CatCardConfig',
        name: 'CatCardConfig',
        component: CatCardConfig
      }, {
        path: '/Layout/ApproveCenter',
        name: 'ApproveCenter',
        component: ApproveCenter
      }, {
        path: '/Layout/CreateUser',
        name: 'CreateUser',
        component: CreateUser
      }, {
        path: '/Layout/TaskConfig',
        name: 'TaskConfig',
        component: TaskConfig
      }, {
        path: '/Layout/Inventory',
        name: 'Inventory',
        component: Inventory
      }, {
        path: '/Layout/CatGuessList',
        name: 'CatGuessList',
        component: CatGuessList
      }, {
        path: '/Layout/GuessList',
        name: 'GuessList',
        component: GuessList
      }, {
        path: '/Layout/GuessSwitch',
        name: 'GuessSwitch',
        component: GuessSwitch
      }, {
        path: '/Layout/MomentList',
        name: 'MomentList',
        component: MomentList
      }, {
        path: '/Layout/AddMoment',
        name: 'AddMoment',
        component: AddMoment
      }, {
        path: '/Layout/MomentDetail',
        name: 'MomentDetail',
        component: MomentDetail
      }, {
        path: '/Layout/PresentMail',
        name: 'PresentMail',
        component: PresentMail
      }, {
        path: '/Layout/SystemMail',
        name: 'SystemMail',
        component: SystemMail
      }, {
        path: '/Layout/UploadCover',
        name: 'UploadCover',
        component: UploadCover
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js